export default class Contato {
    constructor({
        descricao,
        tipoEntregaCorrespondenciaId,
        tipoContatoId,
        nome,
        principal = false,
        estrangeiro = false
    }) {
        this.descricao = descricao
        this.tipoEntregaCorrespondenciaId = tipoEntregaCorrespondenciaId
        this.tipoContatoId = tipoContatoId
        this.principal = principal
        this.estrangeiro = estrangeiro
        this.nome = nome
    }
}